import React from "react";

const ProgressBar = ({ step }) => {
  const getStepClass = (i) => {
    if (i < step) return "completed";
    if (i === step) return "current";
    return "next";
  };

  return (
    <div className="progress-bar-register">
      <div className={`progress-step ${getStepClass(1)}`}>
        <div className="circle">
          {step > 1 ? (
            <img src="/tick-circle.svg" alt="completed" />
          ) : (
            "1"
          )}
        </div>
        <div className="step-name">Basic Info.</div>
      </div>
      <div className={`progress-step ${getStepClass(2)}`}>
        <div className="circle">
          {step > 2 ? (
            <img src="/tick-circle.svg" alt="completed" />
          ) : (
            "2"
          )}
        </div>
        <div className="step-name">Legal info.</div>
      </div>
    </div>
  );
};

export default ProgressBar;
